import type { ReactNode } from 'react';

/** Metric tile shared by the oversight (SUPERDOC) and admin dashboards. Renders
 *  an icon + label, the value, and an optional footer that is EITHER a coloured
 *  `delta` (up/down trend) OR a muted `hint`. `loading` shows a placeholder. */
export function StatCard({
  icon,
  label,
  value,
  delta,
  hint,
  up,
  loading,
}: {
  icon: ReactNode;
  label: string;
  value: string;
  delta?: string;
  hint?: string;
  up?: boolean;
  loading?: boolean;
}) {
  return (
    <div className="card p-4 sm:p-5">
      <div className="flex items-center gap-2 text-muted-foreground">
        <span className="text-muted-foreground">{icon}</span>
        <span className="text-xs font-medium">{label}</span>
      </div>
      <div className="mt-2 font-display text-[26px] leading-none font-semibold tabular-nums">
        {loading ? '…' : value}
      </div>
      {delta ? (
        <div
          className={`mt-2 font-mono text-[11px] ${up === false ? 'text-destructive' : 'text-primary'}`}
        >
          {delta}
        </div>
      ) : null}
      {hint ? <div className="mt-2 text-[10px] text-muted-foreground">{hint}</div> : null}
    </div>
  );
}
